import type React from 'react';
import { useState } from 'react';

import { Modal } from '@kathondvla/react-shared-components/src/components';

import type { Content } from '@generalTypes/apiTypes';
import {
  addIsIncludedInDocument,
  closeAddGlobalDocumentModal,
} from '@newStore/documentUI/documentUIState';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { GlobalDocumentDropdown } from './GlobalDocumentDropdown';
import './modals.scss';

const GlobalDocumentInsertModal: React.FC<{
  modalTitle?: string;
}> = ({ modalTitle = '' }) => {
  const [selectedGlobalDocument, setSelectedGlobalDocument] = useState<Content | null>(null);

  const dispatch = useDispatch();

  const modalData = useTypedSelector((state) => state.documentUI.addGlobalDocumentModalData.data);

  const handleSubmit = () => {
    if (selectedGlobalDocument && modalData) {
      dispatch(
        addIsIncludedInDocument({
          parentHref: modalData.parentHref,
          includedInDocument: selectedGlobalDocument.$$meta.permalink,
          position: modalData.positionIndex,
        }),
      );
    }

    dispatch(closeAddGlobalDocumentModal());
  };

  const onClose = () => {
    dispatch(closeAddGlobalDocumentModal());
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title={modalTitle || 'Voeg een bijlage toe'} onClose={onClose} />
      <Modal.Body>
        <div className="form-group">
          <GlobalDocumentDropdown
            onChange={setSelectedGlobalDocument}
            selectedGlobalDocument={selectedGlobalDocument}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Ok
        </button>
      </Modal.Footer>
    </div>
  );
};

GlobalDocumentInsertModal.displayName = 'GlobalDocumentInsertModal';

export default GlobalDocumentInsertModal;
